import script from "./WhoWeWorkWithSection.vue?vue&type=script&setup=true&lang=js"
export * from "./WhoWeWorkWithSection.vue?vue&type=script&setup=true&lang=js"

import "./WhoWeWorkWithSection.vue?vue&type=style&index=0&id=63c482ea&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63c482ea"]])

export default __exports__